module.exports = __webpack_public_path__ + "img/coupon-title.1af28f5e.png";